import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';

import { Loader, Notice, Drawer } from 'UI';

import { useAuthContext } from 'Hooks';
import { canCreateUser } from 'Helpers';

const Home = lazy(() => import('Pages/Home'));
const Request = lazy(() => import('Pages/Request'));
const Requests = lazy(() => import('Pages/Requests'));
const Factory = lazy(() => import('Pages/Factory'));
const NotFound = lazy(() => import('Pages/NotFound'));
const NotAccess = lazy(() => import('Pages/NotAccess'));

const App = (): JSX.Element => {
  const { user } = useAuthContext();

  return (
    <Router basename="/ui">
      <Drawer>
        <Suspense
          fallback={
            <Wrapper>
              <Loader size={15} />
            </Wrapper>
          }
        >
          {user && (
            <>
              {user.isActive ? (
                <>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="request/*" element={<Request />} />
                    <Route path="requests/*" element={<Requests />} />
                    {canCreateUser({ user, label: 'CLIENT' }) && (
                      <Route path="factory/*" element={<Factory />} />
                    )}
                    <Route path="404" element={<NotFound />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </>
              ) : (
                <Routes>
                  <Route path="/" element={<NotAccess />} />
                  <Route path="*" element={<NotAccess />} />
                </Routes>
              )}
            </>
          )}
        </Suspense>
        <Notice />
      </Drawer>
    </Router>
  );
};

const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
`;

export default App;
